import { useMemo } from "react";
import { keyBy } from "@common/helpers/collections";
import { useCategoriesTree } from "./useCategoriesTree";

export function useCategoriesById() {
    const categories = useCategoriesTree();
    return useMemo(
        () =>
            keyBy(
                categories.map((c) => [c, ...(c.subcategories ?? [])]).flat(),
                (c) => c.id,
            ),
        [categories],
    );
}
